const FullScreenIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.53105 1.6934L3.21699 1.00747C3.23351 0.990863 3.24504 0.969956
             3.25027 0.947122C3.2555 0.924289 3.25421 0.900447 3.24656 0.878307C3.23891
             0.856168 3.2252 0.83662 3.20699 0.821887C3.18878 0.807154 3.1668 0.797827 3.14355
             0.794968L0.640427 0.499655C0.560739 0.49028 0.491989 0.557468 0.501364 0.638718L0.796677 
             3.14184C0.809177 3.24497 0.935739 3.28872 1.00918 3.21528L1.69199 2.53247L3.78105 4.61997C3.82949 4.66841
             3.90918 4.66841 3.95761 4.61997L4.62011 3.95903C4.66855 3.91059 4.66855 3.83091 4.62011 
             3.78247L2.53105 1.6934ZM8.04199 4.61997C8.09043 4.66841 8.17011 4.66841 8.21855 4.61997L10.3076
             2.53247L10.9904 3.21528C11.007 3.2318 11.0279 3.24333 11.0508 3.24856C11.0736 3.25379 11.0974 3.25251 
             11.1196 3.24485C11.1417 3.2372 11.1613 3.22349 11.176 3.20528C11.1907 3.18707 11.2001 3.16509 
             11.2029 3.14184L11.4982 0.64028C11.5076 0.560593 11.4404 0.491843 11.3592 0.501218L8.85605 
             0.79653C8.75293 0.80903 8.70918 0.935593 8.78261 1.00903L9.46855 1.69497L7.37949 3.78091C7.35623 
             3.8044 7.34318 3.83612 7.34318 3.86919C7.34318 3.90225 7.35623 3.93397 7.37949 3.95747L8.04199 4.61997ZM11.2029 
             8.85747C11.1904 8.75434 11.0639 8.71059 10.9904 8.78403L10.3076 9.46684L8.21855 7.37934C8.19506 7.35608 8.16333 
             7.34303 8.13027 7.34303C8.09721 7.34303 8.06548 7.35608 8.04199 7.37934L7.37949 8.04028C7.35623 8.06377 7.34318 
             8.0955 7.34318 8.12856C7.34318 8.16162 7.35623 8.19335 7.37949 8.21684L9.46855 10.3059L8.78261 10.9918C8.76609 
             11.0084 8.75456 11.0294 8.74933 11.0522C8.74411 11.075 8.74539 11.0989 8.75304 11.121C8.76069 11.1431 8.7744 11.1627 
             8.79261 11.1774C8.81082 11.1922 8.8328 11.2015 8.85605 11.2043L11.3592 11.4997C11.4389 11.509 11.5076 11.4418 
             11.4982 11.3606L11.2029 8.85747ZM3.95761 7.37934C3.93412 7.35608 3.9024 7.34303 3.86933 7.34303C3.83627 7.34303 
             3.80455 7.35608 3.78105 7.37934L1.69199 9.46684L1.00918 8.78403C0.992572 8.76751 0.971665 8.75598 0.948831 8.75075C0.925998 
             8.74552 0.902156 8.7468 0.880017 8.75445C0.857877 8.76211 0.838329 8.77582 0.823596 8.79403C0.808863 8.81224 0.799536 
             8.83422 0.796677 8.85747L0.501364 11.359C0.491989 11.4387 0.559177 11.5075 0.640427 11.4981L3.14355 11.2028C3.24668 
             11.1903 3.29043 11.0637 3.21699 10.9903L2.53105 10.3059L4.62011 8.2184C4.66855 8.16997 4.66855 8.09028 4.62011 
             8.04184L3.95761 7.37934Z"
      fillOpacity="0.65"
    />
  </svg>
);
export default FullScreenIcon;
